module.exports = __webpack_public_path__ + "img/flag_ua.ac77af09.svg";